import React, { useEffect, useState } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { FloatingLabel, Button, Col, Form, Row, InputGroup, Modal } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import fr from 'date-fns/locale/fr';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import Newucrm from '../crm/New';

const NewDemand = () => {
    registerLocale('fr', fr);
    setDefaultLocale('fr');
    const [showModal, setShowModal] = useState(false);
    const [valueClientId, setValueClientId] = React.useState(null);
    const [valueVillaPossible, setValueVillaPossible] = React.useState([]);
    const [valueVilla, setValueVilla] = React.useState(null);
    const [valueStatut, setValueStatut] = React.useState(null);
    const [valueOrigin, setValueOrigin] = React.useState(null);
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({ origin_id: generateString() });
    const [l, setL] = React.useState(false);
    const [is_moral, setMoral] = React.useState(false);
    const [is_owner, setIs_Owner] = React.useState(false);
    const [clients, setClients] = React.useState([]);
    const [checkIn, setCheckIn] = React.useState(null);
    const [checkOut, setCheckOut] = React.useState(null);
    // const [booked_date, setBooked_Date] = React.useState(new Date());
    const [demand_date, setDemand_Date] = React.useState(new Date());
    const [emails, setEmails] = React.useState('');
    const [villas, setVilla] = React.useState([]);
    const [valueInterlocuteur, setValueInterlocuteur] = React.useState(null);
    const [interlocuteurs, setInterlocuteur] = React.useState([]);
    const [valueEquipment, setValueEquipment] = React.useState(null);
    const [equipements, setEquipements] = React.useState([]);
    const [services, setServices] = React.useState([]);
    const [servicesList, setServicesList] = React.useState([]);

    const navigate = useNavigate();


    const loadList = () => {
        // get list clients and format
        firebase.firestore().collection('equiments').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                const dr = { value: d.id, label: d.data()?.title }
                s.push(dr)
            })
            setEquipements(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

        firebase.firestore().collection('services').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                const dr = { value: d.id, label: d.data()?.title }
                s.push(dr)
            })
            setServicesList(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    }

    const loadVilla = () => {
        firebase.firestore().collection('properties').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                var l = d.data();
                if (l?.delete) {
                    // supprimer donc ne pas affiché
                } else {
                    const dr = { value: d.id, label: `${l?.nameHouse}` }
                    s.push(dr)
                }

            })
            setVilla(s);
        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    }

    const loadUsers = () => {
        firebase.firestore().collection('users').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                var l = d.data();
                if (l?.delete) {
                    // supprimer donc ne pas affiché
                } else {
                    if (l?.type === "admin") {
                        const dr = { value: d.id, label: `${l?.lastName} ${l?.firstName}`, phone: l.phone, email: l.email, }
                        s.push(dr)
                    }
                }

            })
            setInterlocuteur(s);
        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    }


    const getClients = () => {
        // get list clients and format
        firebase.firestore().collection('crm').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                let pre = d.data()?.email?.split(',') || []
                pre.forEach((s) => {
                    e += `${s}, `;
                })
                const dr = { value: d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, email: e }
                if (d.data()?.delete) { }
                else {
                    s.push(dr)
                }
            })
            setClients(s);
        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

    }

    useEffect(() => {
        getClients();
        loadVilla()
        loadList()
        loadUsers()
    }, []);

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        // console.log(formd)
        if (form.checkValidity() === false) {
            toast.error("Des champs sont manquant ou invalide");
            return;
        }

        if (l) {
            return;
        }

        var t = formd
        t.checkin = checkIn;
        t.checkout = checkOut;
        // t.booked_date = new Date();
        t._create_At = new Date();
        t._update_At = new Date();
        t.demand_date = demand_date;
        t.guest = {
            firstName: t?.client?.label.split(' ')[1],
            lastName: t?.client?.label.split(' ')[0]
        }
        let dds = t?.email?.split(',');
        let sd = []
        dds?.forEach(s => {
            if (validateEmail(s?.trim())) {
                sd.push(s?.trim());
            }
        })
        t.emails = sd;



        setValidated(true);
        setL(true);
        let al = t.email
        try {
            firebase.firestore().collection('demands').add(t).then((doc) => {
                console.log("Document successfully written!");
                toast.success("Demande créer avec succès");
                let sd = {
                    statut: "Création",
                    date: new Date(),
                    data: t,
                    uid: firebase.auth().currentUser.uid
                }
                firebase.firestore().collection(`demands/${doc.id}/logs`).add(sd)
                navigate('/demands');
            }).catch((error) => {
                setL(false);
                var errorMessage = error.message;
                toast.error(errorMessage);
                t.email = al
            })
        } catch (error) {
            setL(false);
            t.email = al
            var errorMessage = error.message;
            toast.error(errorMessage);
        }

    };


    const handleChange = e => {
        let d = formd;
        console.log(e.target.name, e.target?.checked, e.target?.value);
        if (e.target.name === "is_owner") {
            d[e.target.name] = e.target.checked;
            setIs_Owner(e.target.checked)
        } else {
            if (e.target.name === "type") {
                d[e.target.name] = e.target.value === "moral" ? "moral" : "physique";
                setMoral(e.target.value === "moral")
            } else {
                d[e.target.name] = e.target.value;
                if (e.target.name === "email") {
                    setEmails(e.target.value)
                }
            }
        }

        setFrom(d);
    };

    function generateString() {
        // Générer une chaîne aléatoire pour les trois premiers caractères (X)
        const randomDigits = Array.from({ length: 3 }, () => Math.floor(Math.random() * 10)).join('');

        // Obtenir la date actuelle
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Les mois sont 0-indexés
        const year = String(currentDate.getFullYear());

        // Créer la chaîne finale en utilisant le format requis
        const dateString = `${day}${month}${year}`;

        // Concaténer les parties pour former la chaîne finale
        const finalString = `${randomDigits}_${dateString}`;

        return finalString;
    }


    return (
        <FalconComponentCard>
            <FalconComponentCard.Header title="Nouvelle demande" light={false} noPreview={true} />
            <FalconComponentCard.Body >
                <Form noValidate validated={validated} onSubmit={handleSubmit}>

                    <Row className="mb-3">
                        <Form.Group as={Col} md="5" controlId="bookingorder">
                            <Form.Label>Client</Form.Label>
                            <Select
                                required
                                options={clients}
                                placeholder={clients.length === 0 ? 'Chargement...' : 'Choisir le client...'}
                                classNamePrefix="react-select"
                                value={valueClientId}
                                onChange={value => {
                                    let d = formd;
                                    d['client'] = value;
                                    setFrom(d);
                                    if (valueClientId?.value !== value.value) {
                                        // si changement de client on efface email et on réinit
                                        let f = formd
                                        f['email'] = null;
                                        setFrom(f);
                                        setEmails('')
                                    }
                                    setValueClientId(value)
                                    console.log("value", value)
                                    console.log(formd['email'])
                                    if (formd['email'] === undefined || formd['email'] === null || formd['email'] === '') {
                                        let id = value.value
                                        clients.forEach(d => {
                                            if (d.value === id) {
                                                let f = formd
                                                f['email'] = d.email
                                                setFrom(f);
                                                setEmails(d.email)
                                            }
                                        })
                                    }

                                }
                                }
                            />
                            {formd && formd.client === undefined && <p><a href={`#`} onClick={() => setShowModal(true)}  >Nouveau client</a></p>}

                        </Form.Group>
                        <Form.Group as={Col} md="5" controlId="villa">
                            <Form.Label>Propriété</Form.Label>
                            <Select
                                options={villas}
                                placeholder='Choisir la villa...'
                                classNamePrefix="react-select"
                                value={valueVilla}
                                onChange={value => {
                                    setValueVilla(value)
                                    let d = formd;
                                    d['property'] = value;
                                    setFrom(d);

                                }}
                            />
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md="5" controlId="interlocuteur">
                            <Form.Label>Interlocuteur</Form.Label>
                            <Select options={interlocuteurs}
                                placeholder='Choisir interlocuteur...'
                                classNamePrefix="react-select"
                                value={valueInterlocuteur}
                                onChange={value => {
                                    setValueInterlocuteur(value)
                                    let d = formd;
                                    d['interlocuteur'] = value;
                                    setFrom(d);
                                }}
                            />
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md="5" controlId="bookingorder">
                            <Form.Label>Status de la demande</Form.Label>
                            <Select
                                required
                                options={[
                                    { value: 'canceled', label: 'Annuler' },
                                    { value: 'created', label: 'En cours' },
                                    { value: 'confirmed', label: 'Confirmer' },
                                ]}
                                placeholder='Choisir le status...'
                                classNamePrefix="react-select"
                                value={valueStatut}
                                onChange={value => {
                                    setValueStatut(value)

                                    let d = formd;
                                    d['statut'] = value;
                                    setFrom(d);

                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="5" controlId="bookingorder">
                            <Form.Label>Origine de la demande</Form.Label>
                            <Select
                                options={[
                                    { value: 'direct', label: 'Direct' },
                                    { value: 'website', label: 'Site Internet' },
                                    { value: 'partner', label: 'Partenaire' },
                                ]}
                                placeholder="Choisir l'origine..."
                                classNamePrefix="react-select"
                                value={valueOrigin}
                                onChange={value => {
                                    setValueOrigin(value)


                                    let d = formd;
                                    d['origin'] = value;
                                    setFrom(d);

                                }}
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="4" controlId="originid">
                            <Form.Label>Numéro de demande interne (id origin)</Form.Label>
                            <Form.Control
                                type="text"
                                name="origin_id"
                                onChange={handleChange}
                                value={formd?.origin_id}
                                placeholder="Identifiant interne"
                            />
                        </Form.Group>


                        {/* <Form.Group as={Col} md="4" controlId="originid">
                <Form.Label>Numéro de commande (aibnb, booking, ...)</Form.Label>
                <Form.Control  
                    type="text"
                    name="number_booking"
                    onChange={handleChange}
                    placeholder="Numéro de commande..." 
                /> 
                </Form.Group> */}

                        <Form.Group as={Col} md="4" controlId="total_pay">
                            <Form.Label>Prix total à payée (en €)</Form.Label>
                            <Form.Control
                                type="text"
                                name="total_pay"
                                onChange={handleChange}
                                placeholder="Tarif total de la demande de réservation"
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="4" controlId="adultNbr">
                            <Form.Label>Nombre total d'adulte</Form.Label>
                            <Form.Control
                                type="number"
                                name="adultNbr"
                                onChange={handleChange}
                                placeholder="Nombre total d'adulte"
                                min={1}
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="4" controlId="kidsNbr">
                            <Form.Label>Nombre total d'enfant</Form.Label>
                            <Form.Control
                                type="number"
                                name="kidsNbr"
                                onChange={handleChange}
                                placeholder="Nombre total d'enfant"
                                min={0}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="roomsNbr">
                            <Form.Label>Nombre total de chambre</Form.Label>
                            <Form.Control
                                type="number"
                                name="roomsNbr"
                                value={formd.roomsNbr}
                                onChange={handleChange}
                                placeholder="Nombre total de chambre"
                                min={0}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="zone_geo">
                            <Form.Label>Zone géographique</Form.Label>
                            <Form.Control
                                type="text"
                                name="zone_geo"
                                onChange={handleChange}
                                placeholder="Indiquez la zone géographique souhaité"
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="10" controlId="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="text"
                                name="email"
                                value={emails}
                                onChange={handleChange}
                                placeholder="Email du client "
                                required
                            />

                            <Form.Text className="text-warning fs--1">
                                Séparer par une virgule (ex: email@bohouse.com, email2@bohouse.com)
                            </Form.Text>
                        </Form.Group>

                        <Form.Group as={Col} md="4" controlId="phone">
                            <Form.Label>Téléphone</Form.Label>
                            <Form.Control
                                type="text"
                                name="phone"
                                onChange={handleChange}
                                placeholder="Téléphone du client"
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="3" controlId={`ScheduleStartDate`}>
                            <Form.Label>Check-in</Form.Label>

                            <DatePicker
                                showTimeSelect
                                dateFormat="dd/MM/yyyy HH:ss"
                                selected={checkIn}
                                startDate={checkIn}
                                endDate={checkOut}
                                timeFormat="p"
                                selectsStart
                                onChange={newDate => {
                                    let d = formd;
                                    d['checkin'] = newDate;
                                    setFrom(d)
                                    setCheckIn(newDate)
                                }}
                                customInput={
                                    <CustomDateInput
                                        formControlProps={{
                                            placeholder: 'jj/mm/yyyy',
                                            //     ...register(`ScheduleStartDate${index}`)
                                        }}
                                    />
                                }
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="3" controlId={`ScheduleEndDate`}>
                            <Form.Label>Check-out</Form.Label>

                            <DatePicker
                                selected={checkOut}
                                showTimeSelect
                                minDate={checkIn}
                                selectsEnd
                                startDate={checkIn}
                                endDate={checkOut}
                                dateFormat="dd/MM/yyyy HH:ss"
                                onChange={newDate => {
                                    let d = formd;
                                    d['checkout'] = newDate;
                                    setFrom(d)
                                    setCheckOut(newDate)
                                }}
                                customInput={
                                    <CustomDateInput
                                        formControlProps={{
                                            placeholder: 'jj/mm/yyyy',
                                            //     ...register(`ScheduleStartDate${index}`)
                                        }}
                                    />
                                }
                            />
                        </Form.Group>
                        <hr className="mt-3" />

                        {/* <Form.Label>Information sur la demande</Form.Label>  */}

                        <Row className="mb-3">
                            <Form.Group as={Col} md="5" controlId="demand_date">
                                <Form.Label>Date de la demande</Form.Label>
                                <DatePicker
                                    selected={demand_date}
                                    dateFormat="dd/MM/yyyy"
                                    onChange={newDate => {
                                        let d = formd;
                                        d['demand_date'] = newDate;
                                        setFrom(d)
                                        setDemand_Date(newDate)
                                    }}
                                    customInput={
                                        <CustomDateInput
                                            formControlProps={{
                                                placeholder: 'jj/mm/yy',
                                                //     ...register(`ScheduleStartDate${index}`)
                                            }}
                                        />
                                    }
                                />
                            </Form.Group>
                        </Row>

                        <hr className="mt-3" />

                        <Form.Group as={Col} md="4" controlId="budget_week">
                            <Form.Label>Budget par semaine (€)</Form.Label>
                            <Form.Control
                                type="text"
                                name="budget_week"
                                onChange={handleChange}
                                placeholder="Indiquez le budget par semaine"
                            />
                        </Form.Group>
                        <hr className="mt-3" />
                        <Form.Group as={Col} md="5" controlId="villaPossible">
                            <Form.Label>Liste des biens souhaité</Form.Label>
                            <Select
                                options={villas}
                                isMulti
                                closeMenuOnSelect={false}
                                placeholder='Choisir les biens...'
                                classNamePrefix="react-select"
                                value={valueVillaPossible}
                                onChange={value => {
                                    setValueVillaPossible(value)
                                    let d = formd;
                                    d['villaPossible'] = value;
                                    setFrom(d);

                                }}
                                isDisabled={formd?.canEdit === false}
                            />
                        </Form.Group>

                        <hr className="mt-3" />
                        <Form.Group as={Col} md="10" controlId="equipment">
                            <Form.Label>Equipements demandé</Form.Label>
                            <Select
                                closeMenuOnSelect={false}
                                isMulti
                                options={equipements}
                                placeholder='Choisir les équipements ...'
                                classNamePrefix="react-select"
                                value={valueEquipment}
                                onChange={value => {
                                    setValueEquipment(value)
                                    let d = formd;
                                    d['equipments'] = value;
                                    setFrom(d);
                                }}
                            />

                            <Form.Text className="text-warning fs--1">
                                <p>pas dans la liste, <a target="_blank" href="/equiment/new">Ajouté</a>
                                    <IconButton
                                        variant="falcon-default"
                                        size="sm"
                                        icon="reload"
                                        className="me-1 mb-2 mb-sm-0"
                                        iconClassName="me-1"
                                        onClick={() => { loadList() }}>
                                        recharger la liste d'equipement
                                    </IconButton></p>


                            </Form.Text>
                        </Form.Group>
                        <hr style={{ marginTop: 10 }} />


                        <Row className="mb-3">
                            <Form.Label>Services demandé par le client</Form.Label>
                            {
                                services.map((service, index) => {
                                    return (<Row className="mb-3">



                                        <Form.Group as={Col} md="3" controlId="pricePer">
                                            <Form.Label>Service</Form.Label>
                                            <Select
                                                options={
                                                    servicesList
                                                }
                                                placeholder='Choisir...'
                                                classNamePrefix="react-select"
                                                value={service?.service}
                                                onChange={(value) => {
                                                    let o = [...services];
                                                    let m = { ...service };
                                                    m.service = value
                                                    o[index] = m;
                                                    setServices(o);
                                                    let d = { ...formd };
                                                    d['services'] = o;
                                                    setFrom(d);
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="3" className="mb-3">
                                            <Form.Label>Titre</Form.Label>
                                            <Form.Control
                                                name={`serviceTitle_${index}`}
                                                placeholder="Titre"
                                                value={service.title}
                                                onChange={(e) => {
                                                    let o = [...services];
                                                    let m = { ...service };
                                                    m.title = e.target.value
                                                    o[index] = m;
                                                    setServices(o);
                                                    let d = { ...formd };
                                                    d['services'] = o;
                                                    setFrom(d);
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group as={Col} md="5" controlId="description">
                                            <Form.Label>Description</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={service?.description}
                                                name={`serviceDescription_${index}`}
                                                onChange={(e) => {
                                                    let o = [...services];
                                                    let m = { ...service };
                                                    m.description = e.target.value
                                                    o[index] = m;
                                                    setServices(o);
                                                    let d = { ...formd };
                                                    d['services'] = o;
                                                    setFrom(d);
                                                }}
                                                placeholder="Description du service ..."
                                            />
                                        </Form.Group>


                                        <IconButton as={Col} md="1" onClick={() => {
                                            let arr = services;
                                            arr.splice(index, 1);
                                            setServices(arr);
                                            let d = { ...formd };
                                            d['services'] = arr;
                                            setFrom(d);
                                        }}
                                            variant="falcon-danger"
                                            size="sm"
                                            icon="trash"
                                            transform="shrink-3"
                                            className='me-2'
                                            style={{ width: 60, height: 25, marginTop: 35 }}
                                        >
                                        </IconButton>
                                    </Row>)
                                })
                            }

                            <div>
                                <Flex
                                    alignItems="center"
                                    className="mb-4 text-primary cursor-pointer fs-0"
                                    onClick={() => {
                                        let o = [...services];
                                        if (o[o.length - 1]?.title?.trim() !== "" && o[o.length - 1]?.description?.trim() !== "") {
                                            o.push({ service: null, title: "", description: "" });
                                            setServices(o);
                                        }
                                    }}
                                >
                                    <span className="circle-dashed">
                                        <FontAwesomeIcon icon="plus" />
                                    </span>
                                    <span className="ms-3">Ajouter un nouveau service</span>
                                </Flex>
                            </div>

                            {services[services.length - 1]?.service === null && (
                                <Form.Text className="text-warning fs--1">
                                    <p>pas dans la liste, <a target="_blank" href="/service/new">Ajouté</a> <IconButton
                                        variant="falcon-default"
                                        size="sm"
                                        icon="reload"
                                        className="me-1 mb-2 mb-sm-0"
                                        iconClassName="me-1"
                                        onClick={() => { loadList() }}>
                                        recharger la liste des services
                                    </IconButton></p>
                                </Form.Text>
                            )}



                        </Row>

                        <hr className="mt-3" />
                        <Form.Label>Commentaire</Form.Label>
                        <Form.Group className="mb-3">

                            <Form.Control as="textarea" name="comment"
                                placeholder="Laisser un commentaire ici"
                                style={{ height: '100px' }}
                                onChange={handleChange}
                            />
                        </Form.Group>




                    </Row>

                    <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Créer'}</Button>
                </Form>

                {/* Modal d'ajout d'un nouveau client */}
                <Modal fullscreen show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Ajouter un nouveau client</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Newucrm canRedirect={false} redirectHere={(value) => {
                            let clientsm = clients
                            clientsm.push(value);
                            let d = formd;
                            d['client'] = value;
                            setFrom(d);
                            if (valueClientId?.value !== value.value) {
                                // si changement de client on efface email et on réinit
                                let f = formd
                                f['email'] = null;
                                setFrom(f);
                                setEmails('')
                            }
                            setValueClientId(value) 
                            if (formd['email'] === undefined || formd['email'] === null || formd['email'] === '') {
                                let id = value.value
                                clientsm.forEach(d => {
                                    if (d.value === id) {
                                        let f = formd
                                        f['email'] = d.email
                                        setFrom(f);
                                        setEmails(d.email)
                                    }
                                })
                            }

                            setShowModal(false)
                        }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Fermer
                        </Button>
                    </Modal.Footer>
                </Modal>
            </FalconComponentCard.Body>
        </FalconComponentCard>
    );
};

export default NewDemand;
